/*
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandiweb/gdpr-scandipwa
 * @author    Reinis Mazeiks <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Html from 'Component/Html';
import Popup from 'Component/Popup';

import { PRIVACY_POLICY_POPUP_ID } from './PrivacyPolicyPopup.config';

/** @namespace Gdpr/Component/PrivacyPolicyPopup/Component/PrivacyPolicyPopupComponent */
export class PrivacyPolicyPopupComponent extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            PrivacyPolicyPopupComponent: PropTypes.shape({
                privacyPolicy: PropTypes.string
            })
        })
    };

    static defaultProps = {
        payload: {}
    };

    renderContent() {
        const { payload: { PrivacyPolicyPopupComponent: { privacyPolicy = false } = {} } = {} } = this.props;

        if (!privacyPolicy) {
            return null;
        }

        return (
            <article>
                <Html content={ privacyPolicy } />
            </article>
        );
    }

    render() {
        return (
            <Popup
              id={ PRIVACY_POLICY_POPUP_ID }
              clickOutside={ false }
              mix={ { block: 'MyAccountPrivacySettingsPopup' } }
            >
                { this.renderContent() }
            </Popup>
        );
    }
}

export default PrivacyPolicyPopupComponent;
